import Image from "next/image";

const PersonAvatar = ({ avatar, name }) => {
  // @todo for the time being, don't render images here as optimised because next.js is looking for content-type
  //  of image/* to render images, otherwise it crashes. There should really be an option
  //  https://github.com/vercel/next.js/issues/23523

  return (
    <div className="person-avatar flex-shrink-0 flex-grow-0 mb-4 text-center me-2 me-md-4">
      {avatar && (
        <div className="img-container rounded-circle overflow-hidden">
          <Image
            src={avatar}
            width={56}
            height={56}
            className="rounded-circle"
            unoptimized={true}
          />
        </div>
      )}
      <p className="mb-0 small line-clamp-2">{name}</p>
    </div>
  );
};

export default PersonAvatar;
